/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { authorModelPagedResultSchema } from "../authorModelPagedResultSchema.ts";
import { authorTypeEnumSchema } from "../authorTypeEnumSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

export const getApiAuthorsQueryParamsSchema = z.object({
    "AuthorIds": z.array(z.string().uuid()).describe("Фильтр по идентификаторам").optional(),
"TypeFilter": z.array(z.lazy(() => authorTypeEnumSchema).describe("Тип авторов. \n\r\n1 - Исполнитель \n\r\n2 - Подкастер \n\r\n3 - Проповедник \n\r\n4 - Чтец \n<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Artist</b>: Исполнитель.</li>\n<li><b>2 - Podcaster</b>: Подкастер.</li>\n<li><b>3 - Preacher</b>: Проповедник.</li>\n<li><b>4 - Reader</b>: Чтец.</li>\n</ul>\n")).describe("Фильтр по типу авторов.\n\r\n1 - Исполнитель \n\r\n2 - Подкастер \n\r\n3 - Проповедник \n\r\n4 - Чтец \n").optional(),
"GetPopular": z.boolean().describe("Получить популярных").optional(),
"GetNewest": z.boolean().describe("Получить новых авторов").optional(),
"SortByName": z.boolean().describe("Сортировка по имени").optional(),
"SortByNameDesc": z.boolean().describe("Сортировка по имени с конца").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Список авторов
 */
export const getApiAuthors200Schema = z.lazy(() => authorModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiAuthors400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiAuthors401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiAuthors403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiAuthors500Schema = z.lazy(() => badResponseModelSchema)

export const getApiAuthorsQueryResponseSchema = z.lazy(() => getApiAuthors200Schema)